import React, { useState, useEffect } from "react";
import { NavLink, useNavigate } from "react-router-dom";
import "../../styles/login.css";
import Header from "../../pages/homepage/Header";
import { ToastContainer, toast } from "react-toastify";

import "react-toastify/dist/ReactToastify.css";
// Login component represents the login page
export default function TcLogin() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);

  const navigate = useNavigate();

  useEffect(() => {
    const auth = localStorage.getItem("user");
    if (auth) {
      navigate("/tc/dashboard");
    }
  }, []);

  const handleLogin = async (e) => {
    e.preventDefault();
    // Basic input validation
    if (!email || !password) {
      toast.warn("Please enter both email and password.", {
        position: "top-left",
        autoClose: 2000,
        theme: "dark",
      });
      return;
    }
    try {
      let result = await fetch("http://localhost:8000/tc/login", {
        method: "post",
        body: JSON.stringify({ email, password }),
        headers: {
          "Content-Type": "application/json",
        },
      });

      result = await result.json();

      if (result) {
        localStorage.setItem("user", JSON.stringify(result));
        navigate("/tc/dashboard");
      } else {
        alert("Invalid credentials. Please try again.");
      }
    } catch (error) {
      localStorage.clear();
      console.error("Error during fetch operation:", error);
    }
  };

  return (
    <div>
      <Header />
      {/* Login Form */}
      <section>
        <div className="container mt-5 pt-5">
          <div className="row">
            <div className="col-12 col-sm-7 col-md-6 m-auto">
              <div className="card border-0 shadow custom-card-width custom-card">
                <div className="card-body p-4">
                  {/* User Icon */}
                  <div className="d-flex justify-content-center">
                    <i className="fa-solid fa-user"></i>
                  </div>

                  {/* Login Form */}
                  <form>
                    <input
                      type="email"
                      name="email"
                      id="email"
                      className="form-control my-4 py-2"
                      placeholder="Email"
                      onChange={(e) => setEmail(e.target.value)}
                      value={email}
                    />
                    <div className="input-group my-4 py-2">
                    <input
                      type={showPassword ? "text" : "password"}
                      name="password"
                      id="password"
                      className="form-control"
                      placeholder="Password"
                      onChange={(e) => setPassword(e.target.value)}
                      value={password}
                    />
                    <span
                      className="input-group-text"
                      onClick={() => setShowPassword(!showPassword)}
                      style={{ cursor: "pointer" }}
                    >
                      {showPassword ? (
                        <i className="fa-regular fa-eye-slash"></i>
                      ) : (
                        <i className="fa-regular fa-eye"></i>
                      )}
                    </span>
                  </div>
                    <div className="text-center mt-3">
                      <button
                        onClick={handleLogin}
                        className="btn btn-outline-light w-100"
                      >
                        Login
                      </button>
                      <p className="p-2 text-light">
                        Don't have an Account?
                        <br />
                        <NavLink
                          className="btn text-light "
                          type="button"
                          id="form-open"
                          to="/tc/signup"
                        >
                          Sign-up
                        </NavLink>
                      </p>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section><ToastContainer/>
    </div>
  );
}
